import { clsx } from 'clsx';

import type { IconProps } from 'components/Icon';

import styles from './VarIndicator.module.css';

import { Icon } from 'components/Icon';

export type StatusType = 'DRAFT' | 'REJECTED' | 'SUBMITTED' | 'ACTIVE';

export interface VarIndicatorProps {
  /** Label on the indicator */
  label: Record<StatusType, string>;
  /** Status type 'DRAFT' | 'REJECTED' | 'SUBMITTED' | 'ACTIVE' */
  variant?: StatusType;
  /** Maximum number of steps if variant is 'SUBMITTED' */
  maxSteps?: number;
  /** Current step if variant is 'SUBMITTED' */
  currentStep?: number;
  /** If set shows compact view and opens to the left on hover */
  isCompact?: boolean;
  onClick?: () => void;
}

const ICON_NAMES = {
  DRAFT: 'CircleLarge',
  REJECTED: 'CircleLarge',
  SUBMITTED: 'CircleLargeDotted',
  ACTIVE: 'SignalActive',
};

export const VarIndicator = ({
  label,
  variant = 'DRAFT',
  maxSteps,
  currentStep = 1,
  isCompact,
  onClick,
}: VarIndicatorProps) => {
  const IndicatorContent = () => (
    <>
      <Icon name={ICON_NAMES[variant] as IconProps['name']} size={16} />
      <span className={styles['var-indicator__label']}>{label[`${variant}`]}</span>
      {maxSteps &&
        maxSteps > 0 &&
        variant === 'SUBMITTED' &&
        Array.from({ length: maxSteps }, (_, idx) => idx + 1).map((step) => (
          <div key={step} className={styles['var-indicator__step-container']}>
            <Icon name={step <= currentStep ? 'CircleSmallFilled' : 'CircleSmall'} />
          </div>
        ))}
    </>
  );

  return (
    <button
      className={clsx(
        styles['var-indicator__container'],
        styles[`var-indicator__container--${variant.toLowerCase()}`],
        {
          [styles['var-indicator__container--compact']]: isCompact,
        }
      )}
      onClick={onClick}
    >
      {isCompact ? (
        <>
          <Icon name={ICON_NAMES[variant] as IconProps['name']} size={16} />
          <div
            className={clsx(
              styles['var-indicator__container'],
              styles['var-indicator__container--compact-flyover-wrapper']
            )}
          >
            <IndicatorContent />
          </div>
        </>
      ) : (
        <IndicatorContent />
      )}
    </button>
  );
};
